














































import { Component, Provide, Watch, Prop, Vue } from 'vue-property-decorator';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { Severity } from '@sentry/types';

export type TAvailableAdditionalWedge = {
  name: string;
  description: string;
  value: string;
};

@Component({
  components: {
    ModuleVionicRecommendationsAdditionalWedgesDialog: () =>
      import('@/components/modules/vionic/recommendations/ModuleVionicRecommendationsAdditionalWedgesDialog.vue'),
  },
})
export default class ModuleVionicRecommendationsAdditionalWedges extends Vue {
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;

  @Provide() dialog: boolean = false;
  @Provide() error: typeof Error | null = null;
  @Provide() currentAdditionalWedges: any = [];

  @Provide() availableAdditionalWedges: TAvailableAdditionalWedge[] = [
    {
      name: 'HEEL LIFTS',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam aut blanditiis cum, deleniti eius esse ipsam iusto, labore magnam quae quidem repellat reprehenderit tenetur vel voluptatem. Dolorum expedita facilis quibusdam.',
      value: 'heel_lifts',
    },
    {
      name: 'FOREFOOT VALGUS',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam aut blanditiis cum, deleniti eius esse ipsam.',
      value: 'forefoot_valgus',
    },
    {
      name: 'PRIOR',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam aut blanditiis cum, deleniti eius esse ipsam iusto, labore magnam quae quidem repellat.',
      value: 'prior',
    },
    {
      name: 'CUST',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam aut blanditiis cum, deleniti eius esse ipsam iusto, labore magnam quae.',
      value: 'cust',
    },
    {
      name: 'HOKE',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam aut blanditiis cum, deleniti eius esse ipsam iusto, labore magnam quae quidem repellat reprehenderit tenetur vel voluptatem. Dolorum expedita facilis quibusdam.',
      value: 'hoke',
    },
    {
      name: 'DANNE',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam aut blanditiis cum, deleniti eius esse ipsam iusto, labore magnam quae quidem repellat reprehenderit tenetur.',
      value: 'danne',
    },
    {
      name: 'CUST34',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam aut blanditiis cum, deleniti eius esse ipsam iusto, labore magnam quae.',
      value: 'cust34',
    },
    {
      name: 'EASY',
      description: 'Designed for the patient with an “average” weight and activity level and general orthotic.',
      value: 'easy',
    },
  ];

  async save() {
    try {
      // Try to patch the patient ...
      const patchedPatient: TEntity<TPatient> = await this.$pdc.repository!.emit('patch', 'patients', {
        patientId: null,
        data: {
          'acquisitions.$.data.additionnal_wedges': this.currentAdditionalWedges,
        },
        query: {
          _id: this.patient._id,
          'acquisitions._id': this.acquisition._id,
        },
      });
      this.$store.commit('pdc/entities/patients/PATCH_ONE', patchedPatient);
    } catch (e) {
      this.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    }
  }
  findAdditionalWedge(val: string, type: string) {
    const additionalWedge: any = this.availableAdditionalWedges.find((x: any) => x.value === val);
    return additionalWedge[type];
  }
}
